import { faAngleDown, faCompass, faHouse, faKey } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import constants from "../constants/constants";
import SEO, { pageSEO } from "../components/seo.component";
import { motion } from "framer-motion";
import { fadeUp, stagger } from "../functions/animations";

export default function BuyerGuide() {
  const [open, setOpen] = useState(
    new Array(constants.BUYING_GUIDE.length).fill(false)
  );

  const seoConfig = pageSEO.buyerGuide();

  const toggleAccordion = (index) => {
    const temp = [...open];
    temp[index] = !temp[index];
    setOpen(temp);
  };

  return (
    <>
      <SEO {...seoConfig} />

      <section className="relative overflow-hidden bg-[#F8FAFC] pt-36 pb-24">
        <div className="absolute right-0 top-0 h-[500px] w-[500px] rounded-full bg-harbour-blue/5 blur-3xl" />
        <div className="absolute bottom-0 left-0 h-[350px] w-[350px] rounded-full bg-harbour-accent/10 blur-3xl" />

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          className="relative mx-auto max-w-[1200px] px-6"
        >

          <div className="mb-16 text-center">

            <motion.div
              variants={fadeUp}
              className="flex items-center justify-center gap-4"
            >
              <div className="h-px w-14 bg-harbour-accent" />

              <span className="uppercase tracking-[0.5em] text-harbour-blue">
                Home Buying Journey
              </span>

              <div className="h-px w-14 bg-harbour-accent" />
            </motion.div>

            <motion.h1
              variants={fadeUp}
              className="mt-8 font-serif text-5xl leading-tight text-harbour-navy md:text-6xl"
            >
              Your Guide To
              <br />
              Finding Home
            </motion.h1>

            <motion.p
              variants={fadeUp}
              className="mx-auto mt-8 max-w-2xl text-lg leading-8 text-harbour-muted"
            >
              Navigate every step of your buying journey with confidence.
              From understanding the market to receiving the keys, we provide
              the guidance you need to make informed decisions.
            </motion.p>
          </div>

          <div className="grid gap-12 lg:grid-cols-[280px_1fr]">
            <motion.div
              variants={fadeUp}
              className="hidden lg:block"
            >
              <div className="sticky top-32 rounded-[32px] bg-harbour-navy p-8 text-white">
                <FontAwesomeIcon
                  icon={faCompass}
                  className="text-3xl text-harbour-accent"
                />

                <h3 className="mt-8 font-serif text-3xl">
                  Start Your
                  <br />
                  Journey
                </h3>

                <p className="mt-5 text-sm leading-7 text-white/70">
                  Explore the essential steps to buying your next property
                  with expert guidance along the way.
                </p>

                <div className="mt-8 space-y-5 text-sm">
                  <div className="flex items-center gap-3">
                    <FontAwesomeIcon icon={faHouse} className="text-harbour-accent" />
                    Find Your Home
                  </div>

                  <div className="flex items-center gap-3">
                    <FontAwesomeIcon icon={faKey} className="text-harbour-accent" />
                    Close With Confidence
                  </div>
                </div>
              </div>
            </motion.div>

            <div className="space-y-5">
              {constants.BUYING_GUIDE.map((guide, index) => (
                <motion.div
                  variants={fadeUp}
                  key={index}
                  className="overflow-hidden rounded-[28px] border border-harbour-border bg-white shadow-sm transition hover:shadow-xl"
                >
                  <button
                    onClick={() => toggleAccordion(index)}
                    className="group flex w-full items-center justify-between px-7 py-7 text-left md:px-10"
                  >

                    <div className="flex items-center gap-5">
                      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-harbour-blue/10 text-harbour-blue shrink-0">
                        <span className="text-sm font-medium">
                          {String(index + 1).padStart(2, "0")}
                        </span>
                      </div>

                      <h2 className="font-serif text-2xl text-harbour-navy transition group-hover:text-harbour-blue md:text-3xl">
                        {guide.heading}
                      </h2>
                    </div>

                    <FontAwesomeIcon
                      icon={faAngleDown}
                      className={`text-harbour-accent transition-transform duration-300 ${open[index] ? "rotate-180" : ""
                        }`}
                    />
                  </button>

                  <div
                    className={`grid transition-all duration-500 ease-in-out ${open[index]
                      ? "grid-rows-[1fr]"
                      : "grid-rows-[0fr]"
                      }`}
                  >
                    <div className="overflow-hidden">
                      <div className="border-t border-harbour-border px-7 pb-8 pt-6 text-harbour-muted leading-8 md:px-10">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: guide.text,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>
      </section>
    </>
  );
}
